import * as React from 'react';

import { Messages } from '../../codegen/Localize';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { fetchLocalisedValue } from './ServerStatus';

export interface AdminAnalysisTableProps{
    inServerArea: boolean;
    analysisUrl: (sheetUrlId: string) => string;
    isOnlineEnvironment?: boolean;
    isBridgeEnabled?: boolean;
    hidePerformanceofFlowRunsOnSite?: boolean;
    hideStatsForLoadTimes?: boolean;
    hidePerformanceofViews?: boolean;
    hidePerformanceofFlowRuns?: boolean;
    navigateUrl?: string;
}

export class AdminAnalysisTable extends React.PureComponent<AdminAnalysisTableProps> {
    private AdminAnalysisView = (view: string, localizationKey: string, detailsLocalizationKey: string): JSX.Element => {
        return (
        <tr>
            <td className="tb-data-grid-separator-row">
                <span className="tb-data-grid-cell-text tb-lr-padded-wide" data-tb-test-id={'status-viz-link-'+view}>
                    <a href={this.props.analysisUrl(view)} >
                        {fetchLocalisedValue(localizationKey)}
                    </a>
                </span>
            </td>
            <td className="tb-data-grid-separator-row">
                <span className="tb-data-grid-cell-text tb-lr-padded-wide">
                    {fetchLocalisedValue(detailsLocalizationKey)}
                </span>
            </td>
        </tr>);
    }

    private inServerAreaAdminView = (): JSX.Element => {
        return (
        <>
            {this.AdminAnalysisView('BackgroundTaskDelays', 'backgroundTaskDelaysTitle', 'backgroundTaskDelaysDetails')}
            {!this.props.hidePerformanceofViews? this.AdminAnalysisView('PerformanceofViews', 'performanceofViewsTitle', 'performanceofViewsDetails'): null}
            {!this.props.hidePerformanceofFlowRuns? this.AdminAnalysisView('PerformanceofFlowRuns', 'performanceofFlowRunsTitle', 'performanceofFlowRunsDetails'): null}
            {FeatureFlags.lowDiskSpaceEnabled? this.AdminAnalysisView('ServerDiskSpace', 'serverDiskSpaceTitle', 'serverDiskSpaceDetails'): null}
            {FeatureFlags.desktopReportingEnabled? this.AdminAnalysisView('DesktopLicenseUsage', 'desktopLicenseUsageTitle', 'desktopLicenseUsageDetails'): null}
            {FeatureFlags.desktopReportingEnabled? this.AdminAnalysisView('DesktopLicenseExpirations', 'desktopLicenseExpirationsTitle', 'desktopLicenseExpirationsDetails'): null}
            {FeatureFlags.staleContentAdminViewEnabled? this.AdminAnalysisView('StaleContent', 'staleContentTitle', 'staleContentDetails'): null}
            {FeatureFlags.serverOverviewAdminViewEnabled? this.AdminAnalysisView('ServerOverview', 'serverOverViewTitle', 'serverOverViewDetails'): null}
            {FeatureFlags.askDataPerformanceDashboardEnabled? this.AdminAnalysisView('AskDataUsage', 'askDataUsageDashboardTitle', 'askDataUsageDashboardDetails'): null}
            {FeatureFlags.askDataPerformanceDashboardEnabled? this.AdminAnalysisView('AskDataPerformance', 'askDataPerformanceDashboardTitle', 'askDataPerformanceDashboardDetails'): null}
            {FeatureFlags.dqwAuditVizEnabled? this.AdminAnalysisView('AuditDqwDashboard', 'auditDqwDashboardTitle', 'auditDqwDashboardDetails'): null}
        </>);
    }

    private inServerAreaSiteView = (): JSX.Element => {
        return (
        <>
            {FeatureFlags.staleContentAdminViewEnabled? this.AdminAnalysisView('StaleContent', 'staleContentTitle', 'staleContentDetails'): null}
            {FeatureFlags.serverOverviewAdminViewEnabled? this.AdminAnalysisView('ServerOverviewSiteAdmin', 'serverOverViewTitle', 'serverOverViewDetails'): null}
            {FeatureFlags.askDataUsageDashboardEnabled? this.AdminAnalysisView('AskDataUsage', 'askDataUsageDashboardTitle', 'askDataUsageDashboardDetails'): null}
            {FeatureFlags.dqwAuditVizEnabled? this.AdminAnalysisView('AuditDqwDashboard', 'auditDqwDashboardTitle', 'auditDqwDashboardDetails'): null}
        </>);
    }

    public render(){
        return (
            <>
            <table className="tb-static-grid-table tb-static-grid-table-settings-width">
                <tbody>
                    <tr>
                        <th className="tb-data-grid-headers-line">
                            <span className="tb-data-grid-header-text">
                                {Messages.analysisTableHeaderDashboard()}
                            </span>
                        </th>
                        <th className="tb-data-grid-headers-line">
                            <span className="tb-data-grid-header-text">
                                {Messages.analysisTableHeaderAnalysis()}
                            </span>
                        </th>
                    </tr>
                    {!this.props.isOnlineEnvironment? this.AdminAnalysisView('TraffictoViews', 'trafficToViewsTitle', 'trafficToViewsDetails'): null}
                    {!this.props.isOnlineEnvironment? this.AdminAnalysisView('TraffictoDataSources', 'trafficToDataSourcesTitle', 'trafficToDataSourcesDetails'): null}
                    {this.props.isBridgeEnabled? this.AdminAnalysisView('TraffictoBridgeconnectedDatasources', 'trafficToBridgeDataSourcesTitle', 'trafficToBridgeDataSourcesDetails'): null}
                    {!this.props.isOnlineEnvironment? this.AdminAnalysisView('ActionsbyAllUsers', 'actionsByAllUsersTitle', 'actionsByAllUsersDetails'): null}
                    {!this.props.isOnlineEnvironment? this.AdminAnalysisView('ActionsbySpecificUser', 'actionsByASpecificUserTitle', 'actionsByASpecificUserDetails'): null}
                    {!this.props.isOnlineEnvironment? this.AdminAnalysisView('ActionsbyRecentUsers', 'actionsByRecentlySignedInUsersTitle', 'actionsByRecentlySignedInUsersDetails'): null}
                    {this.AdminAnalysisView('BackgroundTasksforExtracts', 'backgroundTasksExtractsTitle', 'backgroundTasksExtractsDetails')}
                    {FeatureFlags.bridgeExtractRefreshAdminVizEnabled? this.AdminAnalysisView('BridgeTasksforExtracts', 'bridgeTasksExtractsTitle', 'bridgeTasksExtractsDetails'): null}
                    {this.AdminAnalysisView('BackgroundTasksforNonExtracts', 'backgroundTasksNonExtractsTitle', 'backgroundTasksNonExtractsDetails')}
                    {!this.props.hidePerformanceofFlowRunsOnSite? this.AdminAnalysisView('PerformanceofFlowRuns', 'performanceofFlowRunsTitle', 'performanceofFlowRunsDetails'): null}
                    {!this.props.hideStatsForLoadTimes? this.AdminAnalysisView('StatsforLoadTimes', 'statsLoadTimesTitle', 'statsLoadTimesDetails'): null}
                    {this.AdminAnalysisView('StatsforSpaceUsage', 'statsSpaceUsageTitle', 'statsSpaceUsageDetails')}
                    {FeatureFlags.ibaReportingEnabled? this.AdminAnalysisView('LoginBasedLicenseUsage', 'ibaLicenseUsageTitle', 'ibaLicenseUsageDetails'): null}
                    {!this.props.isOnlineEnvironment? this.AdminAnalysisView('BackgrounderDashboard', 'backgrounderDashboardTitle', 'backgrounderDashboardDetails'): null}
                    {this.props.inServerArea ? this.inServerAreaAdminView() : this.inServerAreaSiteView()}
                </tbody>
            </table>
            {this.props.isOnlineEnvironment?
            <div className="tb-settings-msg-pad-top">
                {Messages.adminInsightsDeprecatedViews()}
                <span> &nbsp;
                    <a href={this.props.navigateUrl ? this.props.navigateUrl: null} target="_blank"  rel="noopener noreferrer" >
                        {Messages.adminInsightsProjectName() + '.'}
                    </a>
                </span>
            </div> : null}
            </>);
    }

}